import { TooltipPassThroughMethodOptions, TooltipPassThroughOptions } from "primereact/tooltip";
import { classNames } from "primereact/utils";

export const tooltip: Partial<TooltipPassThroughOptions> = {
  root: ({ context }: TooltipPassThroughMethodOptions) => {
    return {
      className: classNames("absolute", {
        "py-0 px-1":
          context.right ||
          context.left ||
          (!context.right && !context.left && !context.top && !context.bottom),
        "py-1 px-0": context.top || context.bottom,
      }),
    };
  },
  arrow: ({ context }: TooltipPassThroughMethodOptions) => ({
    className: classNames("absolute w-0 h-0 border-transparent border-solid", {
      "-mt-1 border-y-[0.25rem] border-r-[0.25rem] border-l-0 border-r-[#5A686F]": context.right,
      "-mt-1 border-y-[0.25rem] border-l-[0.25rem] border-r-0 border-l-[#5A686F]": context.left,
      "-ml-1 border-x-[0.25rem] border-t-[0.25rem] border-b-0 border-t-[#5A686F]": context.top,
      "-ml-1 border-x-[0.25rem] border-b-[0.25rem] border-t-0 border-b-[#5A686F]": context.bottom,
    }),
  }),
  text: {
    className:
      "px-2 py-1 text-xs bg-[#5A686F] text-white rounded-md whitespace-pre-line break-words",
  },
};
